export type MediaPayload = {
  attachment_id?: number | null;
  visibility: 'public' | 'private';
  mode: 'omitted' | 'public_url' | 'signed_url' | 'temp_asset';
  url?: string;
  access_url?: string;
  mime_type?: string;
  filename?: string;
  file_size?: number;
};

export function getMediaDisplayUrl(media?: MediaPayload | null): string {
  if (!media || media.mode === 'omitted') {
    return '';
  }
  if (media.mode === 'signed_url' && media.access_url) {
    return media.access_url;
  }
  if (media.mode === 'temp_asset' && media.url) {
    return media.url;
  }
  return '';
}
